<template>
  <div class="judgeScoreDetail">
    <a-row v-show="!showDetail" :gutter="24">
      <a-col :span="24">
        <!-- 本次评选共计： 件，已评选件数 件，未评选件数 件。 -->
        <div class="searchBox" style="height: 80px;">
          <div style="line-height: 32px;">{{ $t('admin-judge/tip12') }}：<font color="#ff0000"><b>{{ result.total }}</b></font> {{ result.total > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}，{{ $t('admin-judge/tip13') }} <font color="#ff0000"><b>{{ result.review_num }}</b></font> {{ result.review_num > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}，{{ $t('admin-judge/tip14') }} <font color="#ff0000"><b>{{ result.no_review_num }}</b></font> {{ result.no_review_num > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}。</div>
        </div>
      </a-col>

    </a-row>
    <div v-show="!showDetail" class="searchBox">
      <div
        v-if="user.role !== 3"
        span="6"
        style="width: 280px;display: flex;float:left;"
      >
        <!-- 初评 -->
        <div class="tag">
          {{ $t('admin-judge/judge') }}
        </div>
        <a-select
          v-model="user_id"
          style="width: 200px;"
          @change="changePerson"
        >
          <a-select-option
            v-for="item in users"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div style="width: 340px;display: flex;position: relative;float: left;">
        <!-- 类别 -->
        <div class="tag" style="width: 5em">
          {{ $t('admin-profile-product/type') }}
        </div>
        <a-select
          v-model="cate_ids"
          style="width: 245px;overflow:hidden;"
          @change="changeCateId"
        >
          <a-select-option
            v-for="item in cates"
            :key="item.value"
            :value="item.value"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div style="display: flex;position: relative;float: left;margin-right: 10px;">
        <!-- 名称 -->
        <div class="tag" style="width: 5em">
          {{ $t('admin-message-message/name') }}
        </div>
        <div>
          <a-input
            v-model="searchWord2"
            :placeholder="$t('admin-judge/codeOrName')"
            @change="changeWord"
          />
        </div>
      </div>
      <div>
        <!-- 搜索 -->
        <a-button
          type="primary"
          @click="searchWord = searchWord2"
        >
          {{ $t("user-productInfo-myProduct/search") }}
        </a-button>
        <!-- 查看评审情况 -->
        <a-button
          type="primary"
          style="margin-left: 10px;"
          @click="showReviewStatus"
        >
          查看评审情况
        </a-button>
      </div>
    </div>
    <div style="position: relative;">
      <!-- 反馈右方的小三角 -->
      <a-select
        v-model="feedback_status"
        style="width: 100px;overflow:hidden;position: absolute;right: 8px;top: 20px;z-index: 1;opacity: 0;"
      >
        <a-select-option
          :key="-1"
          :value="-1"
        >
          {{ $t('admin-judge/total') }}
        </a-select-option>
        <a-select-option
          :key="1"
          :value="1"
        >
          有反馈
        </a-select-option>
      </a-select>
    </div>
    <!-- 表格 -->
    <a-table
      v-show="!showDetail"
      :columns="columns"
      :data-source="listFilter"
      class="table"
      :pagination="pagination"
      row-key="id"
      style="padding-bottom:20px"
      :scroll="{ y: 'calc(100vh - 230px)' }"
      @change="getList"
    >
      <!-- 序号 -->
      <span slot="index" slot-scope="text, row, index">
        <div>
          {{ index + 1 + (pagination.current - 1) * 10 }}
        </div>
      </span>
      <!-- 类别 -->
      <span slot="category" slot-scope="text">
        <div>
          {{ catesFormat[text] }}
        </div>
      </span>
      <!-- 作品图片 -->
      <span slot="image" slot-scope="text">
        <div style="position:relative;z-index:9">
          <img :src="text[0] && text[0].thumb_image_url" alt height="50" style="cursor: pointer;" @click="preview(text)">
        </div>
      </span>
      <!-- 作品编号 -->
      <span slot="code" slot-scope="text, row">
        <div style="cursor: pointer;" @click="view(row)">{{ text }}</div>
      </span>
      <!-- 作品名称中文 -->
      <span slot="name_cn" slot-scope="text, row">
        <div style="cursor: pointer;" @click="view(row)">{{ text }}</div>
      </span>
      <!-- 作品名称英文 -->
      <span slot="name_en" slot-scope="text, row">
        <div style="cursor: pointer;" @click="view(row)">{{ text }}</div>
      </span>
      <!-- 分数-可以排序 -->
      <span slot="score" slot-scope="text">
        <div>
          {{ text }}{{ $t('admin-judge/points') }}
        </div>
      </span>
      <!-- 反馈 -->
      <span slot="feedback" slot-scope="text">
        <div style="overflow: hidden;text-overflow:ellipsis;white-space:nowrap;cursor: pointer;" @click="content = text;showModal2 = true">{{ text || '' }}</div>
      </span>

    </a-table>
    <!-- 没有信息展示时显示完成本轮初评 -->
    <!-- 已移除 完成本轮初评 按钮 -->
    <div style="height: 30px;" />
    <!-- 预展示图片组件 -->
    <PreviewImage v-if="previewVisible" :images="images" :index="imagesIndex" @closePreview="closePreview" />
    <!-- 模态框组件 -->
    <Modal
      :show-modal="showModal"
      :cancel-text="$t('register-verify/close')"
      :confirm-text="$t('admin-judge/confirm')"
      @cancel="showModal = false"
      @confirm="submit"
    >
      <div>
        <div>{{ $t('admin-judge/awardsRules') }}</div>
        <div style="font-size: 16px;">{{ $t('admin-judge/rules') }}</div>
        <div style="margin-top: 10px;">{{ $t('admin-judge/result') }}</div>
        <div>
          <a-form-item>
            <!-- 金奖提名选择 -->
            <div style="width: 20%;float: right;position: relative;z-index: 1;">
              <div style="flex: 3;background: rgba( 0, 0, 0, 0.4);padding: 11px 0 12px;cursor: pointer;" @click="changeStatus">
                <img v-show="data.register_status === 0" src="@/assets/icons/trophy_gray.png" alt="logo">
                <img v-show="data.register_status === 1" src="@/assets/icons/trophy.png" alt="logo">
                <a-checkbox :checked="data.register_status === 1" style="display: block;pointer-events: none;" />
                <div style="position: relative;height: 0;top: 20px;">{{ $t('admin-judge/nominationGoldAward') }}</div>
              </div>
            </div>
          </a-form-item>
        </div>
      </div>
    </Modal>

    <!-- 评审情况弹窗 -->
    <Modal
      :show-modal="showReviewStatusModal"
      :cancel-text="$t('register-verify/close')"
      @cancel="showReviewStatusModal = false"
    >
      <div>
        <div style="font-size: 16px; font-weight: bold; margin-bottom: 15px;">评审情况</div>
        <div class="review-status-list">
          <div v-for="(item, index) in reviewStatusList" :key="index" class="review-status-item">
            <div>姓名：{{ item.name }}</div>
            <div>合计：{{ item.total }}</div>
            <div>已评：{{ item.review_num }}</div>
            <div>未评：{{ item.no_review_num }}</div>
          </div>
        </div>
      </div>
    </Modal>
    <Detail v-if="showDetail" :id="detailId" @hideDetail="hideDetail" />
    <Modal
      :show-modal="showModal2"
      :show-confirm="false"
      cancel-text="关闭"
      @cancel="showModal2 = false"
    >
      <div style="max-height: 50vh;overflow: auto;">{{ content }}</div>
    </Modal>
    <Detail v-if="showDetail" :id="detailId" @hideDetail="hideDetail" />
    <Modal
      :show-modal="showModal2"
      :show-confirm="false"
      cancel-text="关闭"
      @cancel="showModal2 = false"
    >
      <div style="max-height: 50vh;overflow: auto;">{{ content }}</div>
    </Modal>
  </div>
</template>
<script>
import { reviewsSearchBefore, reviewsPrimarySearchPost, reviewsUpdateWhole, reviewsUpdateScore } from '@/api/judge'
import { getPageKey, setPageKey } from '@/utils/auth'
import PreviewImage from '@/views/components/PreviewImage'
import Modal from '@/views/components/Modal.vue'
import Detail from '@/views/admin/judge/detail.vue'

const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    scopedSlots: { customRender: 'index' },
    width: '70px'
  },
  {
    title: '类别',
    dataIndex: 'category_id',
    scopedSlots: { customRender: 'category' }
  },
  {
    title: '作品图片',
    dataIndex: 'image',
    scopedSlots: { customRender: 'image' },
    width: '90px'
  },
  {
    title: '作品编号',
    dataIndex: 'pi_code',
    scopedSlots: { customRender: 'code' }
  },
  {
    title: '作品名称',
    scopedSlots: { customRender: 'name_cn' },
    dataIndex: 'name_cn'
  },
  // {
  //   title: '作品名称（英文）',
  //   scopedSlots: { customRender: 'name_en' },
  //   dataIndex: 'name_en'
  // },

  {
    title: '分数',
    dataIndex: 'score',
    scopedSlots: { customRender: 'score' },
    width: '100px',
    sorter: true
  },
  {
    title: '反馈 ▼',
    dataIndex: 'feedback',
    scopedSlots: { customRender: 'feedback' },
    width: '100px'
  }
]

export default {
  components: {
    PreviewImage,
    Modal,
    Detail
  },
  data() {
    return {
      columns,
      users: [], // 所有的初评员信息
      cates: [], // 所有的类别信息
      list: [], // 获取到的所有的作品的信息
      result: {}, // 所有的作品的初评后的信息
      images: [], // 预展示图片数据组
      imagesIndex: 0, // 展示图片数组
      previewVisible: false, // 预览图
      status: 0, // 是否完成了初评
      user_id: 0, // 用户选择的当前初评员的id
      cate_ids: -1, // f用户选择别的分类信息
      searchWord: '', // 关键字
      searchWord2: '', // 1关键字2
      data: { // 需要储存的信息，评的分数，反馈
        score: 0,
        register_status: 0,
        feedback: ''
      },
      dataIndex: -1,
      showModal: false,
      showDetail: false,
      detailId: 0,
      pagination: {
        current: 1,
        total: 0
      },
      feedback_status: -1,
      showModal2: false,
      content: '',
      showReviewStatusModal: false, // 评审情况弹窗
      reviewStatusList: [], // 评审情况列表
      result2: [] // 评审情况数据
    }
  },
  computed: {
    catesFormat() { // 过滤一些东西
      var json = {}
      for (const i in this.cates) {
        json[this.cates[i].value] = this.cates[i].name
      }
      return json
    },
    locale() {
      return this.$i18n.locale
    },
    user() {
      return this.$store.getters.user
    },
    listFilter() {
      return this.list.filter((item) => {
        item.name_cn = item.name_cn || ''
        item.name_en = item.name_en || ''
        return (this.feedback_status === -1 || item.feedback) &&
        (item.pi_code.indexOf(this.searchWord) !== -1 || item.name_cn.indexOf(this.searchWord) !== -1 || item.name_en.indexOf(this.searchWord) !== -1) &&
        (this.cate_ids === -1 ? true : this.cate_ids === item.category_id)
      })
    }
  },
  watch: {
    locale(e) {
      this.columns[0].title = this.$t('admin-judge/index')
      this.columns[1].title = this.$t('admin-profile-product/type')
      this.columns[2].title = this.$t('admin-profile-product/images')
      this.columns[3].title = this.$t('admin-judge/code')
      this.columns[4].title = this.$t('user-productInfo-product/productName')
      // this.columns[5].title = this.$t('user-productInfo-product/productEname')
      this.columns[5].title = this.$t('admin-judge/score')
    },
    listFilter() {
      this.pagination.current = 1
      this.pagination.total = this.listFilter.length
    }
  },
  created() {
    this.columns[0].title = this.$t('admin-judge/index')
    this.columns[1].title = this.$t('admin-profile-product/type')
    this.columns[2].title = this.$t('admin-profile-product/images')
    this.columns[3].title = this.$t('admin-judge/code')
    this.columns[4].title = this.$t('user-productInfo-product/productName')
    // this.columns[5].title = this.$t('user-productInfo-product/productEname')
    this.columns[5].title = this.$t('admin-judge/score')

    if (this.$route.query.judgeConfirmTip) { // 如果传来了此信息，就弹出提示信息
      this.$info({ content: this.$t('admin-judge/tip11') })
      // this.$router.push({ query: {}})
    }

    let params = getPageKey('judgeScore')
    if (params) {
      params = JSON.parse(params)
      this.user_id = this.user.role === 3 ? this.user.id : (params && params.user_id ? Number(params.user_id) : 0)
    }

    reviewsSearchBefore(1, this.user_id || '').then(res => {
      this.users = res.users

      this.user_id = this.user.role === 3 ? this.user.id : (params && params.user_id ? Number(params.user_id) : res.users[0].id)
      this.cates = res.cates

      this.getList()
      if (params) {
        setTimeout(() => {
          if (params.current) this.pagination.current = Number(params.current)
          if (params.searchWord2) {
            this.searchWord2 = params.searchWord2 || ''
            this.searchWord = params.searchWord2 || ''
          }
          if (params.cate_ids) this.cate_ids = Number(params.cate_ids)
        }, 300)
      }
    })
  },
  mounted() {
    document.getElementsByClassName('ant-table-column-sorter-inner')[0].removeAttribute('title')
  },

  methods: {
    // 显示评审情况弹窗
    showReviewStatus() {
      if (this.result2 && this.result2.length > 0) {
        this.reviewStatusList = this.result2
        this.showReviewStatusModal = true
      } else {
        this.$message.info('暂无评审情况数据')
      }
    },
    // 获取评审情况数据
    getReviewStatus() {
      // 评审情况数据已经在API返回的result2中
      if (this.result && this.result.result2) {
        this.result2 = this.result.result2
      }
    },
    getList(page, filters, sorter) {
      if (page && page.current && page.current !== this.pagination.current) {
        this.changePage(page)
        return
      }
      const data = {
        user_id: this.user_id,
        category_id: this.cates.map(i => i.value),
        sort: sorter && sorter.order === 'ascend' ? 'asc' : 'desc'
      }

      reviewsPrimarySearchPost(data).then(res => {
        this.status = res.status
        this.list = res.lists
        this.result = res.result

        // 获取评审情况数据
        if (res.result2) {
          this.result2 = res.result2
        }

        this.pagination.current = 1
      })
    },
    changePage(page) {
      this.setPageKey('current', page.current)
      this.pagination.current = page.current
    },
    changePerson() {
      this.setPageKey('user_id', this.user_id)

      reviewsSearchBefore(1, this.user_id).then(res => {
        this.cates = res.cates
        this.$set(this, 'cate_ids', -1)
        this.getList()
      })
    },
    changeScore(score, id) {
      let index = ''
      for (const i in this.list) {
        if (this.list[i].id === id) {
          index = i
          break
        }
      }
      this.list[index].score = score
    },
    confirm() {
      const that = this
      this.$confirm({
        // content: this.$t('admin-judge/tip16'),
        content: `恭喜您完成初评环节，您共计初评${this.list.length}件作品，提名${this.list.filter(i => i.register_status === 1).length}件金奖作品。提交初评结果后将无法再进行修改，请确认是否提交。`,
        okText: this.$t('view-components-components/confirm'),
        cancelText: this.$t('admin-profile-edit/cancel'),
        onOk() {
          const data = {
            lists: JSON.parse(JSON.stringify(that.list))
          }
          reviewsUpdateWhole(that.user_id, 1, data).then(res => {
            that.status = 1
            that.$message.success({ content: that.$t('view-components-components/submitTip'), key: 'message', duration: 4 })

            that.$router.push({ query: {}})

            if (that.user.role === 3) {
              setTimeout(() => {
                that.$router.push({ path: '/admin/welcome', query: { complete: true }})
              }, 3500)
            }
          })
        },
        onCancel() {
        }
      })
    },
    preview(images) {
      this.images = images.map(i => i.whole_image_url)
      this.imagesIndex = 0
      this.previewVisible = true
    },
    closePreview() {
      this.previewVisible = false
    },
    edit(row, index) {
      this.$set(this, 'data', JSON.parse(JSON.stringify(row)))
      this.dataIndex = index
      this.showModal = true
    },
    submit() {
      // const length = this.listFilter.filter(i => Number(i.register_status) === 1).length

      if (!this.data.score && this.data.score !== 0) {
        return this.$message.warning({ content: this.$t('admin-judge/tip5'), key: 'message', duration: 4 })
      }
      if (this.data.register_status === 1 && this.data.score !== 10) {
        return this.$message.warning({ content: '金奖提名者需得到最高分10分', key: 'message', duration: 4 })
      }

      // if (this.data.register_status === 1 && length >= 1) {
      //   return this.$message.warning({ content: '最多可提名1件作品作为金奖获得者', key: 'message', duration: 4 })
      // }

      const data = {
        user_id: this.data.user_id,
        product_id: this.data.id,
        score: this.data.score,
        feedback: this.data.feedback,
        register_status: this.data.register_status
      }
      reviewsUpdateScore(data).then(res => {
        this.getList()
        this.showModal = false
      })
      // this.list[this.dataIndex + (this.pagination.current - 1) * 10].score = this.data.score
      // this.list[this.dataIndex + (this.pagination.current - 1) * 10].register_status = this.data.register_status
      // this.showModal = false
    },
    view(row) {
      this.detailId = row.id
      this.showDetail = true
    },
    hideDetail() {
      const current = this.pagination.current
      this.getList()
      setTimeout(() => {
        this.pagination.current = current
        this.showDetail = false
      }, 500)
    },

    scoreChange() {
      // 评分变化处理
    },
    changeCateId(value) {
      this.setPageKey('cate_ids', value)
    },
    changeWord(e) {
      this.setPageKey('searchWord2', e.target.value)
    },
    setPageKey(key, value) {
      let pageKey = getPageKey('judgeScore') || '{}'
      pageKey = JSON.parse(pageKey)
      pageKey[key] = value
      setPageKey('judgeScore', JSON.stringify(pageKey))
    }
  }
}
</script>
<style scoped>
  .searchBox {
    padding: 17px 20px;
    background: #ffffff;
    margin-bottom: 10px;
  }

  .tag {
    width: 4em;
    line-height: 32px;
  }

  .table {
    margin-top: 20px;
  }

  .content {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    width: 30vw;
  }

  footer{
    width: 100%;
    height: 70px;
    text-align: right;
    padding: 19px 24px;
    background: #ffffff;
    position: fixed;
    bottom: 0;
    right: 0;
  }

  footer button {
    margin-left: 16px;
  }
.review-status-list {
  max-height: 400px;
  overflow-y: auto;
}
.review-status-item {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #eee;
}
.review-status-item:last-child {
  border-bottom: none;
}
</style>
<style>
  .judgeScoreDetail .ant-select-selection__rendered {
    margin-right: 22px;
  }

  .judgeScoreDetail .ant-select-selection__rendered ul li+li{
    visibility: hidden;
    height: 0 !important;
    margin: 0 !important;
    border: 0 !important;
  }

  .judgeScoreDetail .ant-select-selection__rendered ul li {
    pointer-events: none;
  }

  .judgeScoreDetail .ant-select-selection__rendered ul li .ant-select-selection__choice__remove {
    pointer-events: auto;
  }

  .judgeScoreDetail .radioBox {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    display: flex;
    text-align: center;
  }

  .judgeScoreDetail .radio {
    margin: -15px 4px 0;
  }

  .judgeScoreDetail .radioLabel {
    display: inline-block;
    width: 40px;
    margin-top: 15px;
  }

  .judgeScoreDetail .radioBox .ant-radio {
    margin: 16px 8px 8px;
  }

  .judgeScoreDetail .tagName {
    position: relative;
    top: 45px;
  }

  .judgeScoreDetail .tagScore {
    margin-top: -25px;
    position: relative;
    top: 45px;
  }
</style>
